import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-mail-templates',
  templateUrl: './mail-templates.component.html',
  styleUrls: ['./mail-templates.component.scss']
})
export class MailTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
